import { mergeClasses } from '@fluentui/react-components';

import { useCardLayoutContainerStyles } from './CardLayoutContainer.styles';

interface CardLayoutContainerProps {
  style?: React.CSSProperties
  header?: React.ReactNode
  children: React.ReactNode
  className?: string
  headerClassName?: string
}
const CardLayoutContainer: React.FC<CardLayoutContainerProps> = ({ style, header, children, className, headerClassName }) => {
  const styles = useCardLayoutContainerStyles();

  return (
    <div
      className={mergeClasses('card-layout-container', styles.container, className)}
      style={style}
      data-testid="card-layout-container"
    >
      <div className={mergeClasses('card-header', styles.header, headerClassName)} data-testid="card-layout-header">
        {header}
      </div>

      <div className={styles.content} data-testid="card-layout-content">
        {children}
      </div>
    </div>
  );
};

export default CardLayoutContainer;
